SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportViewOrderDetailsServiceActionView extends SupportServiceActionsBaseView
  id: 'view_order_details'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    hash =
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id: "view_order_details",
      service_action: I18n.t("js.modules.support.view_details")
    @extendHash(hash)

  actionHandler: (event) ->
    url = "/users/#{currentUser.id}/hotel_reservations/#{@order.id}"
    window.open url

  events:
    "click #view_order_details": "actionHandler"

module.exports = SupportViewOrderDetailsServiceActionView
